<template>
  <div class="mc-tag-input">
    <span v-for="(tag, index) in tags" :key="index" class="tag"
      >{{ tag }}<button @click="deleteTag(index)" class="delete-button">&#x2715;</button></span
    >
    <b-form-textarea
      v-model="emailInput"
      @keydown.enter.prevent="addTag"
      class="tag-input"
      :class="{ 'is-invalid': error, 'border-0': true, 'shadow-none': true }"
      :placeholder="`${$t('global.emailAddresReceipt')}`"
      rows="3"
    />
    <div v-if="error" class="invalid-feedback">
      <span>{{ $t(errorMsg) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    recipients: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      emailInput: '',
      tags: this.value,
      error: false,
      errorMsg: null,
    }
  },
  mounted() {
    this.tags = this.recipients
  },
  methods: {
    validateEmail(email) {
      const emailRegex = /^(?:[^\s@]+)@(?:[^\s@]+)\.(?:[^\s@]+)$/
      const punctuationRegex = /[^\w\s]$/
      if (punctuationRegex.test(email)) {
        return false // Reject email with punctuation mark after the domain
      }
      return emailRegex.test(email)
    },
    addTag() {
      if (
        this.emailInput.includes(',') ||
        this.emailInput.includes(' ') ||
        this.emailInput.includes(';')
      ) {
        const emailArray = this.emailInput.split(/[,\s;]/).map((email) => email.trim())
        for (const iterator of emailArray) {
          const validEmails = this.validateEmail(iterator)
          const duplicateEmail = this.tags.includes(iterator)
          if (validEmails && !duplicateEmail) {
            this.tags.push(iterator)
          } else {
            this.error = true
            this.errorMsg = 'global.text.emailInvalid'
          }
        }
        setTimeout(() => {
          this.error = false
        }, 5000)
      } else {
        const validEmails = this.validateEmail(this.emailInput)
        const duplicateEmail = this.tags.includes(this.emailInput)
        if (validEmails && !duplicateEmail) {
          this.tags.push(this.emailInput.trim())
        } else {
          this.error = true
          this.errorMsg = 'global.text.emailInvalid'
          setTimeout(() => {
            this.error = false
          }, 5000)
          return
        }
      }
      this.emailInput = ''
      this.$emit('input', this.tags)
    },
    deleteTag(index) {
      this.tags.splice(index, 1)
      this.$emit('input', this.tags)
    },
  },
}
</script>

<style lang="scss">
.tag {
  display: inline-block;
  background-color: $mep-primary;
  color: white;
  padding: 4px 8px;
  margin-right: 4px;
  margin-bottom: 4px;
  border-radius: 4px;
}

.delete-button {
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  margin-left: 4px;
  color: white;
  font-weight: 600;
}

.tag-input {
  resize: none;
  height: auto;
  min-height: 40px;
}
</style>
